var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-icon active:translate-y-1",on:{"click":_vm.onSort}},[(_vm.sort)?_c('Icon',{attrs:{"name":"sort-by-alpha.svg"}}):_c('Icon',{attrs:{"name":"sort.svg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }